import { Link, useParams } from "react-router-dom";
import { waitlistPlace } from "../domain/registrations";
import { useEvents } from "../state/events";
import { useLocale } from "../state/i18n";
import { useStudents } from "../state/students";
import { ChildSwitcher, PrototypeBanner, StudentNav } from "../components/ui";

export function StudentEvents() {
  const { studentId = "mike" } = useParams();
  const { getStudent } = useStudents();
  const student = getStudent(studentId);
  const { upcomingEvents, pastEvents, registrationsFor } = useEvents();
  const { t } = useLocale();

  if (!student) {
    return (
      <div className="app">
        <PrototypeBanner />
        <main className="shell">
          <p>{t("student.unknown")}</p>
          <Link to="/">{t("student.back")}</Link>
        </main>
      </div>
    );
  }

  const mineUpcoming = upcomingEvents.flatMap((event) => {
    const registration = registrationsFor(event.id).find(
      (row) =>
        row.studentId === student.id &&
        (row.status === "registered" || row.status === "waitlisted"),
    );
    return registration ? [{ event, registration }] : [];
  });
  const minePast = pastEvents.filter((event) =>
    registrationsFor(event.id).some(
      (row) =>
        row.studentId === student.id &&
        (row.status === "registered" || Boolean(row.checkedInAt)),
    ),
  );

  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <StudentNav studentId={student.id} />
        <ChildSwitcher studentId={student.id} />
        <p className="meta">{t("studentEvents.meta")}</p>
        <h1>{t("studentEvents.title")}</h1>
        <p className="lede">{t("studentEvents.lede")}</p>

        {mineUpcoming.length === 0 ? (
          <div className="wire dashed">
            <div className="meta">{t("studentEvents.none")}</div>
            <p style={{ margin: "0.5rem 0 0" }}>
              {t("studentEvents.noneBody", { school: student.school })}
            </p>
          </div>
        ) : (
          mineUpcoming.map(({ event, registration }) => {
            const waitlisted = registration.status === "waitlisted";
            const place = waitlisted
              ? waitlistPlace(registrationsFor(event.id), student.id)
              : null;
            return (
              <div className="wire" key={event.id}>
                <div className="row">
                  <div>
                    <strong>{event.name}</strong>
                    <div className="anno">
                      {event.dateLabel} · {event.timeLabel}
                    </div>
                    <div className="anno">
                      {student.given} {student.family}
                    </div>
                  </div>
                  {waitlisted ? (
                    <div className="tag">
                      {place === 1
                        ? t("studentEvents.waitlistNext")
                        : t("studentEvents.waitlistPlace", { place: place ?? "—" })}
                    </div>
                  ) : (
                    <div className="tag muted">{t("student.registered")}</div>
                  )}
                </div>
              </div>
            );
          })
        )}

        {minePast.length > 0 ? (
          <>
            <h2>{t("studentEvents.past")}</h2>
            <ul className="list-plain">
              {minePast.map((event) => (
                <li key={event.id}>
                  <div className="row">
                    <div>
                      <div className="title">
                        <strong>{event.name}</strong>
                      </div>
                      <div className="anno">
                        {event.dateLabel} · {event.timeLabel}
                      </div>
                    </div>
                    <div className="tag muted">{t("studentEvents.pastTag")}</div>
                  </div>
                </li>
              ))}
            </ul>
          </>
        ) : null}
      </main>
    </div>
  );
}
